module.exports = __webpack_public_path__ + "img/1530316244.7806364c.jpg";